import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "54",
  height: "49",
  viewBox: "0 0 54 49"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  id: "game_sound_icon",
  transform: "translate(1.5 1.5)"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    id: "矩形",
    width: "51",
    height: "46",
    rx: "7",
    fill: "none",
    stroke: "#fff",
    "stroke-miterlimit": "10",
    "stroke-width": "3"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    id: "路径",
    d: "M29.992.155,9.833,3.53a.924.924,0,0,0-.186.052H8.919a.887.887,0,0,0-.891.889V27.565A5.351,5.351,0,1,0,10.7,32.2a5.467,5.467,0,0,0-.037-.637A.9.9,0,0,0,10.7,31.3V12.523l18.731-3.31v13a5.353,5.353,0,1,0,2.676,4.637,5.52,5.52,0,0,0-.037-.639.9.9,0,0,0,.037-.258V.981a.889.889,0,0,0-.733-.875.755.755,0,0,0-.53-.094l-.474.08h-.049A.92.92,0,0,0,29.992.155Z",
    transform: "translate(9.444 4.694)",
    fill: "#fff"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "54",
  height: "49",
  viewBox: "0 0 54 49"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("g", {
  id: "game_soundC_icon",
  transform: "translate(1.5 1.5)"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    id: "矩形",
    width: "51",
    height: "46",
    rx: "7",
    fill: "none",
    stroke: "red",
    "stroke-miterlimit": "10",
    "stroke-width": "3"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    id: "路径",
    d: "M29.992.155,9.833,3.53a.924.924,0,0,0-.186.052H8.919a.887.887,0,0,0-.891.889V27.565A5.351,5.351,0,1,0,10.7,32.2a5.467,5.467,0,0,0-.037-.637A.9.9,0,0,0,10.7,31.3V12.523l18.731-3.31v13a5.353,5.353,0,1,0,2.676,4.637,5.52,5.52,0,0,0-.037-.639.9.9,0,0,0,.037-.258V.981a.889.889,0,0,0-.733-.875.755.755,0,0,0-.53-.094l-.474.08h-.049A.92.92,0,0,0,29.992.155Z",
    transform: "translate(9.444 4.694)",
    fill: "red"
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    id: "矩形-2",
    "data-name": "矩形",
    width: "4",
    height: "51",
    transform: "translate(5.555 6.883) rotate(-45)",
    fill: "red"
  })
], -1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isOn)
    ? (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_6))
}